import {  solana } from '@reown/appkit/networks';

export default {
  IS_DEV: false,
  API_BASE_URL: 'https://api.junk.fun',
  SOLANA_NETWORK: solana,
  // Set in Vercel env vars. `?.` keeps this importable outside Vite (tsx unit tests)
  SOLANA_RPC_URL: import.meta.env?.VITE_SOLANA_RPC_URL,
  SOLANA: {
    PROGRAM: {
      JUNK_FUN_PROGRAM_ID: 'junkTHpAet6MuYuTfHej12Zh12aWeG6tXbB7hnLjTKi',
    },
  },
  FORCE_PRELAUNCH_GATE: false, // Production: always false
  // Feature Flags
  ENABLE_NEW_LEADERBOARDS: false, // Enable burned/cumulative points leaderboards
  ENABLE_NFT_DEBUG_BYPASS: false, // Production: Twitter verification REQUIRED
  ENABLE_NFT_JUNKING: true, // Production: Disable NFT junking feature
  ENABLE_SOLFLARE_CAMPAIGN: false, // Enable Solflare 2x points campaign
  ENABLE_GATE_WALLET_CAMPAIGN: false, // Show Gate Wallet connect button
  ENABLE_SMB_MATRICA_CAMPAIGN: true, // SMB x Matrica NFT-gated campaign (Feb 11-25, 2026)
  ENABLE_MATTLE_CAMPAIGN: false, // Mattle.fun Season 10 campaign (ended)
  ENABLE_DUST_SWAP: true, // Dust swapping enabled on mainnet
  ENABLE_RECLAIM_EXCESS_RENT: true, // Excess rent reclaim panel (SPL WithdrawExcessLamports)
  ENABLE_PNFT_JUNKING: false, // pNFT burning is not supported by the current on-chain burn flow
  // Jupiter API version: 'ultra' (faster, single call) or 'legacy' (2-step quote→swap)
  JUPITER_API_VERSION: 'ultra' as 'ultra' | 'legacy',
  ENABLE_WRAPPED: true, // Enable Wrapped 2025 feature
  WRAPPED_END_DATE: '2026-01-07T23:59:59Z', // When Wrapped becomes archived
  ENABLE_NEW_YEAR_CAMPAIGN: false, // New Year 2026 Campaign ended
  // NFT Tier Thresholds (must match backend constants)
  NFT_TIER_THRESHOLDS: {
    DIAMOND: 50,
    BLACK: 500,
    GOLD: 5000,
    SILVER: 10000,
  },
  // Override WalletConnect metadata for production
  WALLET_CONNECT_METADATA: {
    name: 'Junk.Fun',
    description: 'Junk.Fun - Burn tokens, win prizes',
    url: 'https://www.junk.fun',
    icons: ['https://www.junk.fun/logo.png'],
  },
};
